export interface LoadingState {
    loadingKeys: string[];
}

export const initialState: LoadingState = {
    loadingKeys: [],
};
